export const INTRO_VID_ASPECT = 875 / 1920;
export const WORK = 'WORK';
export const EXPERIMENTATION = 'EXPERIMENTATION';
export const CONTACT = 'CONTACT';
export const NAV_ITEMS = [WORK, EXPERIMENTATION, CONTACT];
export const SCROLL_TIME_MS = 800;
export const MODAL_ANIM_TIME_MS = 500;
